import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/empty';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';


@Injectable()
export class HttpSwitchUserInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(HttpSwitchUserInterceptor.setXSwitchUserHeader(req));
  }
  // Request Interceptor to append x-user-key Header
  private static setXSwitchUserHeader(req: HttpRequest<any>): HttpRequest<any> {
    if (req) {
      let switchUser = localStorage.getItem('x-user-key');
      if (switchUser){
        return req.clone({ setHeaders: { 'x-user-key': switchUser } });
      }

      return req;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/http/http.switch.user.ts